module.exports = __webpack_public_path__ + "img/client-ilustration.ea257ec3.svg";